module.exports = __webpack_public_path__ + "static/img/cirle.0259a64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activityTemplate/cirle.png
// module id = o1m6
// module chunks = 3